import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PaymentInterface } from "../../Entity/Entities/Payment/PaymentInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* paymentSetProcessed(action: ActionInterface): any {
  try {
    const res =
      yield call(Http.patch, `payment/${action.payload?.paymentId}/${action.payload?.verified}`);

      const payment: PaymentInterface = PaymentFactory.create(res.data.data);
    
    yield put({
      type: Constants.GLOBAL_PAYMENT_SET_PROCESSED_SUCCESS,
      payload: {
        payment: payment
      }
    });

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, payment);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPaymentSetProcessed() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_SET_PROCESSED_START, paymentSetProcessed);
}
